import AbstractScene from './AbstractScene.js';

// Constants
import { tags } from '../consts/Tags.js';
import { Sizes } from '../consts/Sizes.js';
import { Colors } from '../consts/Colors.js';

// Prefabs
import ButtonRounded from '../prefabs/ButtonRounded.js';
import MissionTitle from '../prefabs/MissionTitre.js';
import NavTitre from '../prefabs/NavTitre.js';
import BlueMessageBox from '../prefabs/BlueMessageBox.js';
import ButtonLoupe from '../prefabs/ButtonLoupe.js';
import AnswerFeedBack from '../prefabs/AnswerFeedBack.js';

// Data
import posidonieData from '../data/Mission1.js';

export default class Mission1 extends AbstractScene {
    constructor() {
        super({
            key: 'Mission1',
        });
    }
    init(data) {
        this._init(data);
        this.background = null;
        this.isDebriefActive = false; // pour savoir si le debrief est actif ou pas
        this.positionState = 'center'; // valeurs possibles : 'center', 'top', 'bottom', 'left', 'right'
        this.currentIndex = 0; // pour savoir quel cadre est sélectionné
        this.xOffset = 0;
        this.yOffset = 0;
        this.xBigOffset = 0; // pour le texte de la bouteille
        this.firstTime = true; // pour savoir si c'est la première fois qu'on affiche la bouteille

        this.missionData = this.getMissionData(posidonieData);
    }

    preload() {
        this._preload();
    }

    update() {}

    create() {
        this.isFirstTime = true;
        this.cameras.main.setBackgroundColor(Colors.Elmt.Beige);
        this.cameras.main.fadeIn(1000);

        this.sceneContainer = this.add.container(this.width / 2, this.height / 2);

        // background
        this.background = this.add.image(0, 0, 'background-activite-1').setOrigin(0.5);

        this.sceneContainer.add(this.background);

        this.xOffset = this.missionData.xOffset;
        this.yOffset = this.missionData.yOffset;

        // Nav (titre-nav-activite-1) – commence plus haut

        const navTitre = this.add.existing(
            new NavTitre(this, 200, 0, '1', this.getText('Mission1', 'titre'), this.scaleX),
        );

        navTitre.showWithAnimation();

        // Fog (créé invisible au départ)
        const fog = this.add.graphics();
        const containerWidth = this.sceneContainer.width || this.scale.width;
        const containerHeight = this.sceneContainer.height || this.scale.height;

        const fogStartY = containerHeight * 0.5 - containerHeight / 2;
        const fogEndY = containerHeight / 2;
        const fogHeight = fogEndY - fogStartY;

        for (let i = 0; i < fogHeight; i++) {
            const alpha = (i / fogHeight) * 0.8;
            fog.fillStyle(Colors.Elmt.DarkBlue, alpha);
            fog.fillRect(-containerWidth / 2, fogStartY + i, containerWidth, 1);
        }

        this.sceneContainer.add(fog);

        // MissionTitle au-dessus

        this.missionTitle = new MissionTitle(
            this,
            0,
            0,
            1,
            this.getText('Mission1', 'mission'),
            this.getText('Mission1', 'titre'),
            this.getText('Mission1', 'intro'),
            this.scaleX,
        );
        this.missionTitle.setDepth(2);

        this.sceneContainer.add(this.missionTitle);
        // Bouton
        const button = this.add.existing(
            new ButtonRounded(
                this,
                458 * this.scaleX + 86,
                this.cameras.main.height - 32 - 32,
                86 * 2,
                32 * 2,
                this.getText('Mission1', 'buttonLabel1'),
                Colors.Text.DarkBlue,
                Colors.Elmt.White,
                false,
                Colors.Text.White,
                true,
                false,
                'arrow-right',
                null,
            ),
        );
        button.setAlpha(0); // Start invisible

        // ▶️ Sequence d'animations
        this.missionTitle.animateIn();

        // Animation du titre de la mission
        this.tweens.add({
            targets: button,
            alpha: 1,
            duration: 1000,
            ease: 'Sine.easeIn',
        });

        this.uiElements = [fog, this.missionTitle, button];
        button.setInteractive({ cursor: 'pointer' }).on('pointerdown', () => {
            // Fade out tout sauf la nav
            this.tweens.add({
                targets: this.uiElements,
                alpha: 0,
                duration: 500,
                onComplete: () => {
                    this.addConsigne(); // Appelle la suite */
                },
            });
        });
    }

    createFog(fogHeight = height / 2) {
        const width = this.scale.width;
        const height = this.scale.height;
        const fogStartY = height / 2;

        const bottomFog = this.add.graphics();

        for (let i = 0; i < fogHeight; i++) {
            const alpha = i / fogHeight; // de 0 (transparent) à 1 (opaque)
            bottomFog.fillStyle(Colors.Elmt.DarkBlue, alpha);
            bottomFog.fillRect(0, fogStartY + i, width, 1); // x = 0 pour dessiner à partir du bord gauche
        }
    }

    addConsigne() {
        this.isClosing = false;
        const elementsToAnimate = [];

        // add cadre consigne
        const cadre = this.add
            .image(this.width / 2, this.height / 2, 'cadre-consigne-activite-1')
            .setOrigin(0.5, 0.5)
            .setScale(0);
        elementsToAnimate.push(cadre);

        // add consigne text
        const texte = new BlueMessageBox(
            this,
            this.cameras.main.centerX,
            450,
            this.getText('Mission1', 'consigne'),
            500,
        );

        // add icone close
        const close = this.add
            .image(this.width / 2, 70 * 2 + 64 / 2, 'cta-close')
            .setOrigin(0.5, 0.5)
            .setScale(0)
            .setInteractive({ cursor: 'pointer' })
            .on('pointerdown', () => {
                if (this.isClosing) return; // ⛔ empêche de recliquer
                this.isClosing = true;

                this.input.enabled = false;

                const elementsToHide = [cadre, texte, close, loupe, poisson, main];
                let completed = 0;

                elementsToHide.forEach((el) => {
                    this.tweens.add({
                        targets: el,
                        scale: 0,
                        duration: 300,
                        ease: 'Back.easeIn',
                        onComplete: () => {
                            completed++;
                            if (completed === elementsToHide.length) {
                                cadre.destroy();
                                texte.destroy();
                                close.destroy();
                                loupe.destroy();
                                poisson.destroy();
                                main.destroy();

                                // quand tous les éléments ont disparu, on relance l'activité
                                this.addPopupRecherche(this.getText('Mission1', 'nom1'));

                                // Réinitialise le flag si besoin pour autoriser plus tard
                                this.isClosing = false;

                                // this.input.enabled = true;
                            }
                        },
                    });
                });
            });

        elementsToAnimate.push(close);

        // loupe
        const loupe = this.add
            .image(266 * this.scaleX + 40, 112 * 2 + 122 / 2, 'loupe-consigne-activite-1')
            .setOrigin(0.5, 0.5)
            .setScale(0);
        elementsToAnimate.push(loupe);

        // poisson
        const poisson = this.add
            .image(280 * this.scaleX, 125 * 2 + 34 / 2, 'poisson-consigne-activite-1')
            .setOrigin(0.5, 0.5)
            .setScale(0);
        elementsToAnimate.push(poisson);

        // main
        const main = this.add
            .image(294 * this.scaleX + 10, 140 * 2 + 92 / 2, 'main-consigne-activite-1')
            .setOrigin(0.5, 0.5)
            .setScale(0);
        elementsToAnimate.push(main);

        // Appliquer l'animation scale up avec rebound
        elementsToAnimate.forEach((el, index) => {
            this.tweens.add({
                targets: el,
                scale: 1,
                duration: 500,
                ease: 'Back.Out',
                delay: index * 100, // léger décalage pour un effet en cascade
            });
        });
    }

    addPopupRecherche(animalRecherche = 'la grande nacre') {
        // console.log('addPopupRecherche', animalRecherche);

        // console.log('image animal:', `animal-${this.currentIndex + 1}-activite-1`);

        this.isDebriefActive = true;
        this.isAnimating = false;
        const container = this.add
            .image(this.width / 2 - 603 / 2, this.height / 2, 'container-activite-1')
            .setOrigin(0, 0.5);

        this.imageRecherche =
            this.game.data.level === 0
                ? this.add
                      .image(
                          162 * this.scaleX + 180,
                          this.height / 2 - 10,
                          `animal-${this.currentIndex + 1}-activite-1`,
                      )
                      .setScale(1)
                      .setOrigin(0.5)
                : null;

        // console.log('this.imageRecherche', this.imageRecherche);

        const descText = this.add.rexTagText(
            this.imageRecherche ? container.x + 603 / 2 - 15 : container.x + 400 / 2,
            container.y - container.height / 2 + 50,
            `${this.getText(
                'Mission1',
                'recherche',
            )}<class="boldBlue">${animalRecherche}</class> ?`,
            {
                wordWrap: { width: 180 * 2 },
                fontSize: Sizes.Text.h3,
                fontFamily: 'MonteserratMedium',
                color: Colors.Text.Black,
                backgroundColor: 'transparent',
                tags: tags,
            },
        );

        this.obsIcon = this.add
            .image(
                42 * 2,
                this.imageRecherche ? this.height - 76 - 100 : this.height - 76 - 50,
                'question-icon-activite-1',
            )
            .setOrigin(0, 0)
            .setScale(1)
            .setAlpha(0);

        this.consigne2 = this.add
            .rexTagText(
                this.width / 2,
                this.height / 2,
                this.getText('Mission1', 'consigneFleches'),
                {
                    align: 'center',
                    fontSize: '32px',
                    fontFamily: 'MonteserratBold',
                    color: Colors.Text.White,
                    backgroundColor: 'transparent',
                },
            )
            .setOrigin(0.5, 0.5)
            .setAlpha(0);

        let btnX = this.game.data.level === 0 ? this.width / 2 + 90 : this.width / 2;

        const closeButton = new ButtonLoupe(
            this,
            btnX,
            86 * 4 + 50,
            this.getText('Mission1', 'buttonLabel2'),
        );

        const minimize = () => {
            if (this.isAnimating) return;
            this.isAnimating = true;
            this.isDebriefActive = false;

            // Animation de disparition du popup
            this.tweens.add({
                targets: [closeButton, container, descText],
                alpha: 0,
                scale: 0,
                duration: 300,
                ease: 'Sine.easeInOut',
                onComplete: () => {
                    if (this.isFirstTime) {
                        this.consigne2.setAlpha(1);
                    }
                },
            });

            if (this.imageRecherche) {
                this.tweens.add({
                    targets: this.imageRecherche,
                    scale: 0.5,
                    x: 64 + 54 * 2,
                    y: this.height - 100,
                    duration: 500,
                    ease: 'Sine.easeInOut',
                    onComplete: () => {
                        this.imageRecherche.setInteractive({ cursor: 'pointer' });

                        this.tweens.add({
                            targets: this.obsIcon,
                            alpha: 1,
                            duration: 200,
                            ease: 'Sine.easeInOut',
                            onComplete: () => {
                                this.isAnimating = false; // ✅ Le seul endroit où on réactive !
                            },
                        });

                        if (this.firstTime) {
                            this.addActivite();
                            this.firstTime = false;
                        }
                    },
                });
            } else {
                this.tweens.add({
                    targets: this.obsIcon,
                    alpha: 1,
                    duration: 200,
                    ease: 'Sine.easeInOut',
                    onComplete: () => {
                        this.isAnimating = false; // ✅ Si imageRecherche n'existe pas
                    },
                });

                if (this.firstTime) {
                    this.addActivite();
                    this.firstTime = false;
                }
            }
        };

        const maximize = () => {
            if (this.isAnimating) return;
            this.isAnimating = true;
            if (this.imageRecherche) {
                this.imageRecherche.disableInteractive();
            }

            this.tweens.add({
                targets: this.obsIcon,
                alpha: 0,
                duration: 200,
                ease: 'Sine.easeInOut',
            });

            if (this.imageRecherche) {
                this.tweens.add({
                    targets: this.imageRecherche,
                    scale: 1,
                    x: 162 * this.scaleX + 180,
                    y: this.height / 2 - 10,
                    duration: 500,
                    ease: 'Sine.easeInOut',
                    onComplete: () => {
                        this.tweens.add({
                            targets: [closeButton, container, descText],
                            scale: 1,
                            alpha: 1,
                            duration: 300,
                            ease: 'Sine.easeInOut',
                            onComplete: () => {
                                this.isAnimating = false; // Réactive le clic
                            },
                        });
                    },
                });
            } else {
                this.tweens.add({
                    targets: [closeButton, container, descText],
                    scale: 1,
                    alpha: 1,
                    duration: 300,
                    ease: 'Sine.easeInOut',
                    onComplete: () => {
                        this.isAnimating = false; // Réactive le clic
                    },
                });
            }
        };

        closeButton.setInteractive({ cursor: 'pointer' }).on('pointerdown', () => {
            minimize();
        });
        if (this.imageRecherche) {
            this.imageRecherche.setInteractive({ cursor: 'pointer' }).on('pointerdown', () => {
                this.consigne2.setAlpha(0);
                maximize();
            });
            this.imageRecherche.setScale(0.5).setAlpha(0);
            this.tweens.add({
                targets: this.imageRecherche,
                scale: 1,
                alpha: 1,
                ease: 'Back.Out',
                duration: 500,
                delay: 100, // petit décalage si tu veux
            });
        } else {
            this.obsIcon.setInteractive({ cursor: 'pointer' }).on('pointerdown', () => {
                this.consigne2.setAlpha(0);
                maximize();
            });
        }

        // 👇 Animation d’apparition "scale up + fade" au 1er affichage
        [container, descText, closeButton].forEach((el) => {
            el.setScale(0.5).setAlpha(0); // départ réduit + transparent
        });

        this.tweens.add({
            targets: [container, descText, closeButton],
            scale: 1,
            alpha: 1,
            ease: 'Back.Out', // effet pop doux
            duration: 500,
            onComplete: () => {
                this.input.enabled = true;
            },
        });
    }

    addActivite() {
        const centerX = this.width / 2;
        const centerY = this.height / 2;
        const controlSize = 32;
        const offset = 20 + controlSize;

        this.positionStateX = 'center';
        this.positionStateY = 'center';

        // Création des flèches directionnelles
        this.controlUp = this.createControl('up', centerX, offset, -90, () => {
            if (this.positionStateY === 'top') return;
            this.positionStateY = this.positionStateY === 'center' ? 'top' : 'center';
            this.moveBackground();
        });

        this.controlDown = this.createControl('down', centerX, this.height - offset, 90, () => {
            if (this.positionStateY === 'bottom') return;
            this.positionStateY = this.positionStateY === 'center' ? 'bottom' : 'center';
            this.moveBackground();
        });

        this.controlLeft = this.createControl('left', offset, centerY, 180, () => {
            if (this.positionStateX === 'left') return;
            this.positionStateX = this.positionStateX === 'center' ? 'left' : 'center';
            this.moveBackground();
        });

        this.controlRight = this.createControl('right', this.width - offset, centerY, 0, () => {
            if (this.positionStateX === 'right') return;
            this.positionStateX = this.positionStateX === 'center' ? 'right' : 'center';
            this.moveBackground();
        });

        this.addCadresTest();

        // console.log('bouteille image:', this.getText('Mission1', 'bouteilleVideImage'));

        this.bouteille = this.add
            .image(
                389 * this.scaleX + 300,
                this.height - 32 - 120 / 2,
                this.getText('Mission1', 'bouteilleVideImage'),
            )
            .setOrigin(0.5);

        this.addBurgerMenu(2);
    }

    // Fonction pour créer un bouton de contrôle
    createControl(key, x, y, rotationDeg, callback) {
        this.add
            .image(x, y, 'fleche-activite-1')
            .setOrigin(0.5)
            .setScale(1.5)
            .setRotation(Phaser.Math.DegToRad(rotationDeg))
            .setInteractive({ cursor: 'pointer' })
            .on('pointerdown', () => {
                if (this.isFirstTime) {
                    this.consigne2.setAlpha(0);
                    this.isFirstTime = false;
                }
                if (this.isDebriefActive) return; // Ignore le clic si debrief actif
                callback();
            });
    }

    addCadresTest() {
        // Dimensions calculées
        const bgWidth = this.background.width * this.background.scaleX;
        const bgHeight = this.background.height * this.background.scaleY;

        // Function to create a frame with custom size and interactivity

        const createInteractiveFrame = (x, y, width, height, index) => {
            const g = this.add.graphics();
            // No visible stroke or fill, fully transparent
            // g.lineStyle(2, Colors.Elmt.Blue, 1); // Remove or comment out this line
            // g.strokeRect(-width / 2, -height / 2, width, height); // Remove or comment out this line
            g.setPosition(x, y);
            g.setInteractive(
                new Phaser.Geom.Rectangle(-width / 2, -height / 2, width, height),
                Phaser.Geom.Rectangle.Contains,
                { cursor: 'pointer' },
            );
            g.on(
                'pointerdown',
                () => {
                    if (this.isDebriefActive) return;

                    this.checkAnswer(index);
                },
                this,
            );
            this.sceneContainer.add(g);
        };

        // Example of creating frames with different sizes

        // oursin
        createInteractiveFrame(
            this.background.x - bgWidth / 2 + 1010,
            this.background.y - bgHeight / 2 + 920,
            120,
            120,
            0,
        );

        // tortue
        createInteractiveFrame(
            this.background.x - 50 + 50,
            this.background.y - bgHeight / 2 + 700,
            250,
            150,
            1,
        );

        // poulpe
        createInteractiveFrame(this.background.x - 630, this.background.y - 100, 260, 300, 2);

        // hippocampe
        createInteractiveFrame(this.background.x + 800, this.background.y + 100, 120, 200, 3);

        // nacre
        createInteractiveFrame(this.background.x + 420, this.background.y + 350, 150, 180, 4);

        createInteractiveFrame(this.background.x - 350, this.background.y + 350, 150, 180, 5);

        createInteractiveFrame(
            this.background.x - 50 + 50,
            this.background.y - bgHeight / 2 + 400,
            250,
            150,
            6,
        );
        createInteractiveFrame(
            this.background.x - 350,
            this.background.y - bgHeight / 2 + 300,
            250,
            250,
            6,
        );

        createInteractiveFrame(this.background.x + 570, this.background.y + 150, 100, 100, 7);

        createInteractiveFrame(
            this.background.x + 250,
            this.background.y - bgHeight / 2 + 150,
            250,
            150,
            6,
        );

        createInteractiveFrame(this.background.x - 630, this.background.y - 400, 200, 200, 7);
    }

    moveBackground() {
        const bgWidth = this.background.width * this.background.scaleX;
        const bgHeight = this.background.height * this.background.scaleY;

        const maxOffsetX = (bgWidth - this.width) / 2;
        const maxOffsetY = (bgHeight - this.height) / 2;

        let targetX = this.width / 2;
        let targetY = this.height / 2;

        if (this.positionStateX === 'left') {
            targetX += maxOffsetX;
        } else if (this.positionStateX === 'right') {
            targetX -= maxOffsetX;
        }

        if (this.positionStateY === 'top') {
            targetY += maxOffsetY;
        } else if (this.positionStateY === 'bottom') {
            targetY -= maxOffsetY;
        }

        this.tweens.add({
            targets: this.sceneContainer,
            x: targetX,
            y: targetY,
            duration: 500,
            ease: 'Sine.easeInOut',
        });
    }

    checkAnswer(frameIndex) {
        let isCorrect = null;

        if (frameIndex === this.currentIndex) {
            isCorrect = true;
        } else {
            isCorrect = false;
        }
        this.addDebrief(isCorrect);
    }

    addDebrief(isCorrect) {
        this.isDebriefActive = true;

        const feedbackImage = this.add.existing(
            new AnswerFeedBack(
                this,
                this.width / 2,
                this.height / 2,
                isCorrect ? 'bonne-rep-activite-1' : 'mauvaise-rep-activite-1',
                this.getText('Mission1', isCorrect ? 'bonneReponse' : 'mauvaiseReponse'),
            ),
        );

        this.tweens.add({
            targets: feedbackImage,
            scale: 1,
            alpha: 1,
            ease: 'Back.Out',
            duration: 500,
        });

        this.obsIcon.setTexture(
            isCorrect ? 'valide-icon-activite-1' : 'pas-valide-icon-activite-1',
        );

        if (isCorrect && this.currentIndex < this.missionData.noms.length) {
            const originalX = this.bouteille.x;
            const originalY = this.bouteille.y;

            const letterFinalX = 460 * this.scaleX + this.xOffset;
            const letterFinalY = this.height - 33.85 * 2 - this.yOffset;

            this.time.delayedCall(1000, () => {
                this.tweens.add({
                    targets: feedbackImage,
                    scale: 0.5,
                    alpha: 0,
                    ease: 'Back.In',
                    duration: 400,
                    onComplete: () => {
                        feedbackImage.destroy();

                        // ✅ MONTER bouteille + anciennes lettres au centre
                        this.oldLetters = this.feedbackLetters ? [...this.feedbackLetters] : [];
                        const toCenter = [this.bouteille, ...this.oldLetters];

                        this.tweens.add({
                            targets: toCenter,
                            x: (target) => {
                                if (target === this.bouteille) return this.width / 2;
                                const index = this.feedbackLetters.indexOf(target);
                                return (
                                    this.width / 2 + this.missionData.positionsLettersCenter[index]
                                );
                            },
                            y: (target) => {
                                if (target === this.bouteille) return this.height / 2;
                                return this.height / 2 + this.missionData.yOffset2;
                            },
                            scale: (target) => (target === this.bouteille ? 1.2 : 1),
                            ease: 'Sine.easeInOut',
                            duration: 500,
                            onComplete: () => {
                                // ✅ Ajouter la nouvelle lettre dans la bouteille
                                this.letter = this.getText(
                                    'Mission1',
                                    `lettre${this.currentIndex + 1}`,
                                );

                                this.letterText = this.add
                                    .text(
                                        this.width / 2 +
                                            this.missionData.positionsLettersCenter[
                                                this.currentIndex
                                            ],
                                        this.height / 2 + this.missionData.yOffset2,
                                        this.letter,
                                        {
                                            fontSize: Sizes.Text.h3,
                                            color: Colors.Text.White,
                                            fontFamily: 'Binx',
                                        },
                                    )
                                    .setOrigin(0.5)
                                    .setAlpha(0)
                                    .setScale(0.5);

                                this.tweens.add({
                                    targets: this.letterText,
                                    alpha: 1,
                                    scale: 1,
                                    ease: 'Back.Out',
                                    duration: 300,
                                });

                                // ✅ Repartir ensemble après un délai
                                this.time.delayedCall(1000, () => {
                                    this.allLetters = this.feedbackLetters
                                        ? [...this.feedbackLetters]
                                        : [];
                                    this.allLetters.push(this.letterText); // ajouter la nouvelle lettre

                                    // ✅ On stocke la position finale directement dans la lettre
                                    this.letterText.finalX = letterFinalX;
                                    this.letterText.finalY = letterFinalY;

                                    // ✅ Toutes les lettres existantes doivent avoir leur finalX/finalY si pas déjà fait
                                    this.allLetters.forEach((l, i) => {
                                        if (!l.finalX) {
                                            const baseX = 460 * this.scaleX + i * 22;
                                            l.finalX = baseX + this.missionData.xOffset2;
                                        }
                                    });

                                    const targets = [this.bouteille, ...this.allLetters];

                                    this.tweens.add({
                                        targets: targets,
                                        x: (target) =>
                                            target === this.bouteille ? originalX : target.finalX,
                                        y: (target) =>
                                            target === this.bouteille ? originalY : target.finalY,
                                        scale: 1,
                                        ease: 'Sine.easeInOut',
                                        duration: 500,
                                        onComplete: () => {
                                            if (!this.feedbackLetters) this.feedbackLetters = [];
                                            this.feedbackLetters.push(this.letterText);

                                            this.currentIndex++;
                                            if (this.currentIndex >= posidonieData[0].noms.length) {
                                                this.oldLetters = [];
                                                this.feedbackLetters = [];
                                                this.showEndScreen();
                                                return;
                                            }
                                            this.xOffset += 22;

                                            this.obsIcon.setTexture('question-icon-activite-1');
                                            this.isDebriefActive = false;

                                            // ✅ Continue le jeu
                                            this.destroyPopup();
                                            this.addPopupRecherche(
                                                this.getText(
                                                    'Mission1',
                                                    `nom${this.currentIndex + 1}`,
                                                ),
                                            );
                                        },
                                    });
                                });
                            },
                        });
                    },
                });
            });
        } else {
            // ➡ Cas incorrect : classique
            this.time.delayedCall(1000, () => {
                this.tweens.add({
                    targets: feedbackImage,
                    scale: 0,
                    alpha: 0,
                    ease: 'Back.Out',
                    duration: 500,
                    onComplete: () => feedbackImage.destroy(),
                });

                this.obsIcon.setTexture('question-icon-activite-1');
                this.isDebriefActive = false;
            });
        }
    }

    showEndScreen() {
        /* this.destroyActivite(); */
        const duration = 500;
        const elements = [];

        const blocker = this.add.rectangle(
            this.width / 2,
            this.height / 2,
            this.width,
            this.height,
            Colors.Elmt.Beige,
            1,
        );

        // Nav (titre-nav-activite-1) – commence plus haut
        const nav = this.add.image(32 * 2 + 172 / 2, -100, 'titre-nav-activite-1').setOrigin(0.5);

        // ➡️ Titre avec animation spéciale
        const title = this.add
            .text(this.width / 2, this.height / 2 - 220, this.getText('Mission1', 'endTitre'), {
                fontSize: Sizes.Text.h1,
                color: Colors.Text.BleuNovotel,
                fontFamily: 'Binx',
            })
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0);

        // ➡️ Autres éléments à animer ensuite
        const text1 = this.add
            .text(this.width / 2, this.height / 2 - 150, this.getText('Mission1', 'endTexte'), {
                fontSize: Sizes.Text.p,
                color: Colors.Text.DarkBlue,
                fontFamily: 'Monteserrat',
            })
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0.5);

        this.addBouteille('Mission1');

        const icone = this.add
            .image(this.width / 2 - 420, this.height / 2 + 190, 'attention')
            .setAlpha(0)
            .setScale(0.5);

        const text2 = this.add
            .text(this.width / 2, this.height / 2 + 200, this.getText('Mission1', 'endTexte2'), {
                fontSize: Sizes.Text.p,
                color: Colors.Text.DarkBlue,
                fontFamily: 'Monteserrat',
                align: 'center',
                wordWrap: { width: 368 * 2 },
            })
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0.5);

        elements.push(text1, this.bouteille, this.textBouteille, icone, text2);

        // ➡️ Bouton
        const button = this.add
            .existing(
                new ButtonRounded(
                    this,
                    this.width - 64 - 64,
                    this.height - 32 - 32,
                    86 * 2,
                    32 * 2,
                    this.getText('Mission1', 'buttonLabel1'),
                    Colors.Text.White,
                    Colors.Elmt.BleuNovotel,
                    false,
                    Colors.Text.White,
                    true,
                    false,
                    'arrow-right-white',
                    null,
                ),
            )
            .setAlpha(0)
            .setScale(0.5);

        elements.push(button);

        button.setInteractive({ cursor: 'pointer' }).on('pointerdown', () => {
            this.scene.start('Mission2');
        });

        // ➡️ Animation du titre : scale up + down + fade in
        this.tweens.add({
            targets: title,
            alpha: 1,
            scale: 1.2,
            duration: duration,
            ease: 'Back.Out',
            onComplete: () => {
                // ➡️ Retour à scale 1 (rebond)
                this.tweens.add({
                    targets: title,
                    scale: 1,
                    duration: 300,
                    ease: 'Back.Out',
                    onComplete: () => {
                        // ➡️ Quand le titre est fini : animer les autres éléments en cascade
                        elements.forEach((el, index) => {
                            this.tweens.add({
                                targets: el,
                                alpha: 1,
                                scale: 1,
                                ease: 'Back.Out',
                                duration: duration,
                                delay: index * 150,
                            });
                        });
                    },
                });
            },
        });
    }

    destroyPopup() {
        if (this.imageRecherche) {
            this.imageRecherche.destroy();
        }
        this.obsIcon.destroy();
    }

    destroyActivite() {
        this.bouteille.destroy();
        this.feedbackLetters.forEach((letter) => letter.destroy());

        this.feedbackLetters = [];
        this.xOffset = 0;
        this.currentIndex = 0;
        this.positionStateX = 'center';
        this.positionStateY = 'center';
        this.background.destroy();
        this.isDebriefActive = true;
        this.destroyPopup();

        if (this.controlUp) this.controlUp.destroy();
        if (this.controlDown) this.controlDown.destroy();
        if (this.controlLeft) this.controlLeft.destroy();
        if (this.controlRight) this.controlRight.destroy();
    }
}
